<template>
  <question-template :answer="answer" :is-draggable="isDraggable">
    <template v-slot:icon>
      <div class="field">
        <label class="label">&nbsp;</label>
        <div class="control ">
          <button class="button is-text is-icon" @click="$emit('remove')">
            <span class="icon icon-delete"></span>
          </button>
        </div>
      </div>
    </template>
    <template v-if="!answer" v-slot:default>
      <div class="field">
        <ValidationProvider v-slot="{ errors, failed }" rules="required">
          <label class="label">Question Name</label>
          <div class="control">
            <input
              v-model="data.questionText"
              class="input"
              type="text"
              :class="{ 'is-danger': failed }"
            />
          </div>
          <span class="help" :class="{ 'is-danger': failed }">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </div>
      <choices-list
        v-if="hasQuestionChoices"
        v-model="data.formQuestionChoices"
      ></choices-list>
    </template>
    <template v-else v-slot:default>
      <div class="field">
        <ValidationProvider
          v-slot="{ errors, failed }"
          :rules="{ required: question.isRequired }"
        >
          <label class="label">{{ question.questionText }}</label>
          <div v-if="question.questionType == 'TextSingleLine'" class="control">
            <input
              v-model="data.responseText"
              class="input"
              type="text"
              :class="{ 'is-danger': failed }"
            />
          </div>
          <div
            v-else-if="question.questionType == 'TextMultiLine'"
            class="control"
          >
            <textarea
              v-model="data.responseText"
              class="textarea"
              :class="{ 'is-danger': failed }"
            ></textarea>
          </div>
          <div
            v-else-if="question.questionType == 'MultipleChoiceSelectOne'"
            class="control"
          >
            <app-radio
              v-for="(option, index) in question.formQuestionChoices"
              :key="index"
              v-model="data.responseChoices"
              :data="option.formQuestionChoiceID || option.choiceValue"
              :name="question.formQuestionID"
            >
              {{ option.choiceText }}
            </app-radio>
          </div>
          <div
            v-else-if="question.questionType == 'MultipleChoiceSelectMany'"
            class="control"
          >
            <app-checkbox
              v-for="(option, index) in question.formQuestionChoices"
              :key="index"
              v-model="data.responseChoices"
              :value="option.formQuestionChoiceID || option.choiceValue"
            >
              {{ option.choiceText }}
            </app-checkbox>
          </div>

          <div
            v-else-if="question.questionType == 'DateTimePicker'"
            class="control has-icons-right"
          >
            <datepicker
              v-model="data.responseText"
              format="yyyy-MM-dd"
              :class="{ 'is-danger': failed }"
            ></datepicker>
            <!--input v-model="data.responseText" class="input" type="date" /-->
            <span class="icon icon-calendar is-small is-right"></span>
          </div>
          <span class="help is-danger">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </div>
    </template>
    <template v-if="!answer" v-slot:right>
      <div class="field">
        <label class="label">Question Type</label>
        <div class="control">
          <div class="select">
            <select v-model="data.questionType">
              <option
                v-for="f in formats"
                :key="`format-${f.type}`"
                :value="f.type"
              >
                {{ f.displayName }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="field is-grouped-right is-grouped">
        <div class="control">
          <app-checkbox v-model="data.isRequired">Required</app-checkbox>
        </div>
      </div>
    </template>
  </question-template>
</template>

<script>
import isEqual from 'lodash/isEqual';
import QuestionTemplate from './QuestionTemplate';
import ChoicesList from './ChoicesList.vue';
import AppCheckbox from '../AppCheckbox.vue';
import AppRadio from '../AppRadio.vue';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'Question',
  components: {
    QuestionTemplate,
    ChoicesList,
    AppCheckbox,
    AppRadio,
    Datepicker
  },
  extends: QuestionTemplate,
  props: {
    value: {},
    question: {}
  },
  data() {
    return {
      data: this.value || {}
    };
  },
  computed: {
    formats() {
      return this.$store.state.questionFormats;
    },
    hasQuestionChoices() {
      return this.data.questionType.includes('MultipleChoice');
      // return [3, 4].includes(this.data.questionType);
    }
  },
  watch: {
    value: {
      deep: true,
      handler() {
        if (!isEqual(this.value, this.data)) {
          this.data = this.value;
        }
      }
    },
    data: {
      deep: true,
      handler() {
        if (!isEqual(this.value, this.data)) {
          this.$emit('input', this.data);
        }
      }
    }
  }
};
</script>
